/**
 * GraphQL query strings for enrollment multi get-started
 * Extracted for use in E2E environments without Apollo Client dependencies
 */

export const getEnrollmentMultiGetStartedDataQuery = `
  mutation getEnrollmentMultiGetStartedData($submitEnrollmentInput: SubmitEnrollmentInput!) {
    submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
      ... on SubmitEnrollmentSuccess {
        __typename
        path
        enrollmentData {
          progress
          email
          firstName
          lastName
          phoneNumber
        }
      }
      ... on SubmitEnrollmentError {
        __typename
        path
      }
    }
  }`
